import { getNewStatsService } from "../generalUtils";
import { createSelector } from "../reselect";

const getNewStats = getNewStatsService("benchmarks");

type DataObject = {
  data: any[];
  pastPeriod: any[];
  [key: string]: any;
};
const metrics = ["cpa", "cpc", "cpm", "roas"];

export const convertDataToStatsBenchmarks = (
  data: DataObject,
  statsBy: string = "data"
) => {
  if (!data[statsBy]) {
    return [];
  }
  let { metricsBreakdown } = data?.[statsBy]?.[0] || {};
  if (!metricsBreakdown?.length) {
    return [];
  }
  const stats = {} as any;
  metricsBreakdown.forEach((x: any) => {
    const serviceId = x.provider_id?.replace("-ads", "") || "";
    const obj = {} as any;
    metrics.forEach((metric) => {
      obj[`${serviceId}_${metric}`] = x[metric] || 0;
    });
    const included_count = stats[x.event_date.value]?.included_count
      ? stats[x.event_date.value].included_count + x.included_count
      :( x.included_count || 0);
    stats[x.event_date.value] = {
      ...stats[x.event_date.value],
      ...obj,
      included_count,
    };
  });
  return stats;
};

const calculateAvg = (arr) =>
  arr.reduce((acc, curr) => acc + curr, 0) / arr.length;

export const getBenchmarksChartsForService = (
  data: any,
  metric: string,
  service: string
) =>
  Object.values(data).map((x: any) => parseFloat(x[`${service}_${metric}`] || 0));

export const getBenchmarksChartsForBlended = (data: any, metric: string) => {
  return Object.values(data).map((x: any) => {
    const value = Object.keys(x)
      .filter((key) => key.includes(metric))
      .map((key) => parseInt(x[key] || 0));
    return calculateAvg(value);
  });
};

const totalShopCount = createSelector([getNewStats], (stats) => {
  return calculateAvg(getBenchmarksChartsForBlended(stats, "included_count"));
});

const blendedCpaBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForBlended(stats, "cpa");
});

const blendedCpaBenchmarksTotal = createSelector(
  [blendedCpaBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const blendedCpcBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForBlended(stats, "cpc");
});

const blendedCpcBenchmarksTotal = createSelector(
  [blendedCpcBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const blendedCpmBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForBlended(stats, "cpm");
});

const blendedCpmBenchmarksTotal = createSelector(
  [blendedCpmBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const blendedRoasBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForBlended(stats, "roas");
});

const blendedRoasBenchmarksTotal = createSelector(
  [blendedRoasBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const facebookCpaBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "cpa", "facebook");
});

const facebookCpaBenchmarksTotal = createSelector(
  [facebookCpaBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const facebookCpcBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "cpc", "facebook");
});

const facebookCpcBenchmarksTotal = createSelector(
  [facebookCpcBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const facebookCpmBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "cpm", "facebook");
});

const facebookCpmBenchmarksTotal = createSelector(
  [facebookCpmBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const facebookRoasBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "roas", "facebook");
});

const facebookRoasBenchmarksTotal = createSelector(
  [facebookRoasBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const googleCpaBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "cpa", "google");
});

const googleCpaBenchmarksTotal = createSelector(
  [googleCpaBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const googleCpcBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "cpc", "google");
});

const googleCpcBenchmarksTotal = createSelector(
  [googleCpcBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const googleCpmBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "cpm", "google");
});

const googleCpmBenchmarksTotal = createSelector(
  [googleCpmBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const googleRoasBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "roas", "google");
});

const googleRoasBenchmarksTotal = createSelector(
  [googleRoasBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const tiktokCpaBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "cpa", "tiktok");
});

const tiktokCpaBenchmarksTotal = createSelector(
  [tiktokCpaBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const tiktokCpcBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "cpc", "tiktok");
});

const tiktokCpcBenchmarksTotal = createSelector(
  [tiktokCpcBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const tiktokCpmBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "cpm", "tiktok");
});

const tiktokCpmBenchmarksTotal = createSelector(
  [tiktokCpmBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);

const tiktokRoasBenchmarksChart = createSelector([getNewStats], (stats) => {
  return getBenchmarksChartsForService(stats, "roas", "tiktok");
});

const tiktokRoasBenchmarksTotal = createSelector(
  [tiktokRoasBenchmarksChart],
  (data) => {
    return calculateAvg(data);
  }
);



const PROPS_TO_SELECTORS = {};

export default {
  PROPS_TO_SELECTORS,
  SELECTORS: {
    totalShopCount,
    blendedCpaBenchmarksChart,
    blendedCpaBenchmarksTotal,
    blendedCpcBenchmarksChart,
    blendedCpcBenchmarksTotal,
    blendedCpmBenchmarksChart,
    blendedCpmBenchmarksTotal,
    blendedRoasBenchmarksChart,
    blendedRoasBenchmarksTotal,
    facebookCpaBenchmarksChart,
    facebookCpaBenchmarksTotal,
    facebookCpcBenchmarksChart,
    facebookCpcBenchmarksTotal,
    facebookCpmBenchmarksChart,
    facebookCpmBenchmarksTotal,
    facebookRoasBenchmarksChart,
    facebookRoasBenchmarksTotal,
    googleCpaBenchmarksChart,
    googleCpaBenchmarksTotal,
    googleCpcBenchmarksChart,
    googleCpcBenchmarksTotal,
    googleCpmBenchmarksChart,
    googleCpmBenchmarksTotal,
    googleRoasBenchmarksChart,
    googleRoasBenchmarksTotal,
    tiktokCpaBenchmarksChart,
    tiktokCpaBenchmarksTotal,
    tiktokCpcBenchmarksChart,
    tiktokCpcBenchmarksTotal,
    tiktokCpmBenchmarksChart,
    tiktokCpmBenchmarksTotal,
    tiktokRoasBenchmarksChart,
    tiktokRoasBenchmarksTotal,
  },
};
